import { StateCreator } from "zustand";
import { WidgetStore, ConfigState, ConfigActions } from "../types";

const initialConfigState: ConfigState = {
  widgetName: null,
  welcomeMessage: null,
};

export const createConfigSlice: StateCreator<
  WidgetStore,
  [],
  [],
  ConfigState & ConfigActions
> = (set) => ({
  ...initialConfigState,

  setWidgetName: (widgetName) => set({ widgetName }),

  setWelcomeMessage: (welcomeMessage) => set({ welcomeMessage }),

  resetConfig: () => set(initialConfigState),
});
